import { defineMessages } from "react-intl";

export const timeZoneMessages = defineMessages({
  label: {
    id: "fW5028",
    defaultMessage: "Time zone",
    description: "preferences select label",
  },
  helper: {
    id: "iroweB",
    defaultMessage: "All dates and times are shown in {timeZone}. Applies to this browser only.",
    description: "preferences select helper text",
  },
  useDefault: {
    id: "TuB2G8",
    defaultMessage: "Default ({timeZone})",
    description: "preferences select option: use the deployment's time zone",
  },
});
